<hr />
<div class="container text-center small">
  &copy; Dillo Copyright 2019. All rights reserved.
</div>
